import { CSSObject, Theme } from '@mui/material'

import { KWordsAvailability } from 'features/inventory/domain/types/kWordsAvailability'

export type KWordsAvailabilityColor = {
  availability: KWordsAvailability
  theme: Theme
}

export const kWordsAvailabilityColor = ({
  availability,
  theme,
}: KWordsAvailabilityColor): CSSObject['color'] => {
  const {
    palette: {
      error: { main: error },
      success: { main: success },
    },
  } = theme

  switch (availability) {
    case 'available': {
      return success
    }
    case 'notAvailable': {
      return error
    }
  }
}
